import ResellerConnector from './ResellerConnector';
import appPaths from '../../constants/appPaths';

export const route = {
    component: ResellerConnector,
    label: 'Reseller Questions',
    to: appPaths.resellerForm,
};

export default [route];
